// Etiquetas de rol (B2C): alinear con `serverless/common/utils/wsgRoleRegistry.ts` → `WSG_ROLE_DEFINITIONS`.

import { Option } from "../components/Atomos/DropDown/DDMultiple";

export enum AccessTypeWithStaff {
    member= "Member",
    dataAdmin= "Data Admin + Member", 
    wsgStaff= "WSG Staff", 
    wsgSuper= "WSG Staff Super", 
  }

export const accessOptions: Option[] = [
    { id: 'DataAdmin', name: 'Data Admin' },
    { id: 'WSGStaff', name: 'WSG Staff' },
    { id: 'WSGStaffSuper', name: 'WSG Staff Super' },
    { id: 'Member', name: 'Member' }
  ];

export const UserAccessOptions: Option[] = [
  { id: "member", name: "Member" },
  { id: "dataAdmin", name: "Data Admin + Member" },
  { id: "wsgStaff", name: "WSG Staff" },
  { id: "wsgSuper", name: "WSG Staff Super" },
];

export const Roles = {
  member: "Member",
  dataAdmin: "Data Admin + Member",
  wsgStaff: "WSG Staff",
  wsgSuper: "WSG Staff Super",
} as const;

export type RoleTypes = keyof typeof Roles;

/** Normalize to `person.role`; accepts key or B2C label (incl. legacy if in `Roles`). */
export function normalizeRoleToKey(role: string | undefined | null): string {
  const t = String(role ?? "").trim();
  if (!t) {
    return "";
  }
  if (Object.prototype.hasOwnProperty.call(Roles, t)) {
    return t as RoleTypes;
  }
  const keys = Object.keys(Roles) as RoleTypes[];
  const found = keys.find((k) => Roles[k] === t);
  return found ?? t;
}